import { defineMessages } from "react-intl";

const AudienceMessages = defineMessages({
  acceptCurrency: {
    defaultMessage:
      "MediaMath accepts currency in the form of XXXX.XX, where cents are separated by a period (.). The following formats are not accepted: X,XXX.XX, XXXX,XX, X XXX.XX, or X XXX,XX.",
    id: "audience.pixels.event.acceptCurrency",
  },
  activate: {
    defaultMessage: "Activate",
    id: "audience.pixels.list.actions.activate",
  },
  active: {
    defaultMessage: "Active",
    id: "audience.status.active",
  },
  adaptive: {
    defaultMessage: "Adaptive",
    id: "audience.segments.list.column.adaptive",
  },
  adaptiveSegment: {
    defaultMessage: "Adaptive Segment",
    id: "audience.segments.list.btn.adaptiveSegment",
  },
  adaptiveSegmentName: {
    defaultMessage: "Adaptive Segment Name",
    id: "audience.segments.segment.form.adaptiveSegmentName",
  },
  addAttr: {
    defaultMessage: "+ Add Attribute",
    id: "audience.pixels.event.addAttr",
  },
  addBehavior: {
    defaultMessage: "Add Behavior",
    id: "audience.segments.addBehavior",
  },
  addBehaviorToolTip: {
    defaultMessage: "Select Advertiser to activate this button",
    id: "audience.segments.addBehaviorToolTip",
  },
  addEventFilter: {
    defaultMessage: "Add Event Filter",
    id: "audience.segments.standard.addEventFilter",
  },
  addLookalikeBtn: {
    defaultMessage: "+ Add Lookalike Model",
    id: "audience.lookalikes.list.btn.add",
  },
  addPixel: {
    defaultMessage: "+ Add Pixel",
    id: "audience.pixels.event.addPixel",
  },
  addToContainer: {
    defaultMessage: "Add Pixels to Container (optional)",
    id: "audience.pixels.event.addToContainer",
  },
  addUrl: {
    defaultMessage: "+ Add URL",
    id: "audience.pixels.event.addUrl",
  },
  advancedTools: {
    defaultMessage: "Advanced Tools",
    id: "audience.segments.segment.adaptive.form.advancedTools",
  },
  advertiser: {
    defaultMessage: "Advertiser*",
    id: "audience.pixels.event.advertiser",
  },
  advertiserColumn: {
    defaultMessage: "Advertiser",
    id: "audience.lookalikes.list.column.advertiser",
  },
  advertiserId: {
    defaultMessage: "Advertiser Id",
    id: "audience.pixels.list.summary.advertiserId",
  },
  advertiserName: {
    defaultMessage: "Advertiser Name",
    id: "audience.pixels.list.summary.advertiserName",
  },
  after: {
    defaultMessage: "After",
    id: "audience.segments.adaptive.after",
  },
  agency: {
    defaultMessage: "Agency*",
    id: "audience.pixels.data.agency",
  },
  agencyConflictError: {
    defaultMessage:
      "Behaviors in a segment cannot belong to advertisers from multiple agencies",
    id: "audience.segments.standard.agencyConflictError",
  },
  agencyId: {
    defaultMessage: "Agency Id",
    id: "audience.pixels.list.summary.agencyId",
  },
  agencyName: {
    defaultMessage: "Agency Name",
    id: "audience.pixels.list.summary.agencyName",
  },
  agreeToTerms: {
    defaultMessage: "I agree to the Terms of Use for data sharing",
    id: "audience.lookalikes.form.agreeToTerms",
  },
  allImpressions: {
    defaultMessage: "All Impressions",
    id: "audience.segments.adaptive.sidepanel.allImpressions",
  },
  AND: {
    defaultMessage: "AND",
    id: "audience.segmentGroups.form.segmentOperator.and",
  },
  apply: {
    defaultMessage: "Apply",
    id: "audience.segments.apply",
  },
  assignmentsLabel: {
    defaultMessage: "Select {type} Segments to add to the group:",
    id: "audience.segmentGroups.form.assignmentsLabel",
    parameterized: true,
  },
  assignmentsTitle: {
    defaultMessage: "Assignments",
    id: "audience.segmentGroups.form.assignmentsTitle",
  },
  attachedStrategyWarning: {
    defaultMessage:
      "Setting this group to Inactive may impact delivery in any strategies that use it. Review related strategies before saving.",
    id: "audience.segmentGroups.form.attachedStrategyWarning",
  },
  attachedStrategyWarningBulkActivate: {
    defaultMessage:
      "Activating these groups may impact delivery in any strategies that use them. Review related strategies before continuing.",
    id: "audience.segmentGroups.bulk.attachedStrategyWarningActivate",
  },
  attachedStrategyWarningBulkDeactivate: {
    defaultMessage:
      "Deactivating these groups may impact delivery in any strategies that use them. Review related strategies before continuing.",
    id: "audience.segmentGroups.bulk.attachedStrategyWarningDeactivate",
  },
  attributes: {
    defaultMessage: "Attributes",
    id: "audience.segments.standard.attributes",
  },
  attrName: {
    defaultMessage: "Attribute Name",
    id: "audience.pixels.event.attrName",
  },
  attrsNotSaved: {
    defaultMessage: "Advertiser Attributes could not be saved",
    id: "audience.pixels.event.attrsNotSaved",
  },
  attrsSaved: {
    defaultMessage: "Advertiser Attributes saved successfully",
    id: "audience.pixels.event.attrsSaved",
  },
  audience: {
    defaultMessage: "Audience",
    id: "audience.segmentGroups.list.type.audience",
  },
  audiencesHeader: {
    defaultMessage: "Audiences",
    id: "audience.header",
  },
  available: {
    defaultMessage: "Available",
    id: "audience.lookalikes.form.availablePixels",
  },
  before: {
    defaultMessage: "Before",
    id: "audience.segments.adaptive.before",
  },
  behaviorError: {
    defaultMessage: "Please add at least one behavior",
    id: "audience.segments.standard.behaviorError",
  },
  behaviorName: {
    defaultMessage: "Behavior Name",
    id: "audience.segments.standard.behaviorName",
  },
  between: {
    defaultMessage: "Between",
    id: "audience.segments.adaptive.between",
  },
  billing: {
    defaultMessage: "Billing",
    id: "audience.pixels.data.billing",
  },
  buildExpression: {
    defaultMessage: "Build Expression*",
    id: "audience.segments.segment.form.fields.buildExpression",
  },
  buildExpressionInfo: {
    defaultMessage:
      'After a Standard Segment is saved, it cannot be edited. If you change the expression of a Standard Segment, a new Standard Segment will be saved.\n\nClick "Save As" to name the new segment.',
    id: "audience.segments.segment.form.fields.buildExpression.tooltip",
  },
  buildModel: {
    defaultMessage: "Build",
    id: "audience.lookalikes.form.buildModel",
  },
  campaignId: {
    defaultMessage: "Campaign ID",
    id: "audience.segments.adaptive.sidepanel.campaignId",
  },
  campaignName: {
    defaultMessage: "Campaign Name",
    id: "audience.segments.adaptive.sidepanel.campaignName",
  },
  campaigns: {
    defaultMessage: "Campaigns",
    id: "audience.segments.adaptive.sidepanel.campaigns",
  },
  campaignStatus: {
    defaultMessage: "Campaign Status",
    id: "audience.segments.adaptive.sidepanel.campaignStatus",
  },
  cancel: {
    defaultMessage: "Cancel",
    id: "audience.pixels.list.emailCode.cancel",
  },
  changedBy: {
    defaultMessage: "Changed By",
    id: "audience.pixels.list.changelog.changedBy",
  },
  changelog: {
    defaultMessage: "View Changelog",
    id: "audience.pixels.list.actions.changelog",
  },
  changeMade: {
    defaultMessage: "Change Made",
    id: "audience.pixels.list.changelog.changeMade",
  },
  click: {
    defaultMessage: "Click",
    id: "audience.segments.adaptive.sidepanel.click",
  },
  configuration: {
    defaultMessage: "Configuration",
    id: "audience.lookalikes.sidepanel.configuration",
  },
  contextual: {
    defaultMessage: "Contextual",
    id: "audience.segmentGroups.list.type.contextual",
  },
  continue: {
    defaultMessage: "Continue",
    id: "audience.segment.groups.continue",
  },
  copyPixelTag: {
    defaultMessage: "Copy Pixel Tag",
    id: "audience.pixels.list.actions.copyPixelTag",
  },
  countries: {
    defaultMessage: "Countries",
    id: "audience.lookalikes.sidepanel.countries",
  },
  countriesError: {
    defaultMessage: "Select between 1 and 5 countries",
    id: "audience.lookalikes.form.countriesError",
  },
  created: {
    defaultMessage: "Created",
    id: "audience.changelog.created",
  },
  createdOn: {
    defaultMessage: "Created On",
    id: "audience.pixels.list.summary.createdOn",
  },
  creatingLookalikeModel: {
    defaultMessage: "Creating…",
    id: "audience.lookalikes.form.creatingLookalikeModel",
  },
  creationDate: {
    defaultMessage: "Creation Date:",
    id: "audience.pixels.list.changelog.creationDate",
  },
  creator: {
    defaultMessage: "Creator",
    id: "audience.segments.list.creator",
  },
  crmDataPixel: {
    defaultMessage: "CRM Data Pixel",
    id: "audience.lookalikes.form.crmDataPixel",
  },
  crmDataPixelError: {
    defaultMessage: "Select a CRM data pixel",
    id: "audience.lookalikes.form.crmDataPixelError",
  },
  crmUserType: {
    defaultMessage: "CRM",
    id: "audience.lookalikes.form.crmUserType",
  },
  currency: {
    defaultMessage: "Currency",
    id: "audience.pixels.event.currency",
  },
  customAttr: {
    defaultMessage: "Custom Attributes",
    id: "audience.pixels.event.customAttr",
  },
  customDateRange: {
    defaultMessage: "Custom Date Range",
    id: "audience.segments.adaptive.customDateRange",
  },
  data: {
    defaultMessage: "Data",
    id: "audience.pixels.list.btn.data",
  },
  dataAttrMapping: {
    defaultMessage: "Data Attribute Mapping",
    id: "audience.pixels.event.dataAttrMapping",
  },
  dataKey: {
    defaultMessage: "Data Key",
    id: "audience.pixels.event.dataKey",
  },
  dataPixelNotSaved: {
    defaultMessage: "Data Pixel could not be saved",
    id: "audience.pixels.data.dataPixelNotSaved",
  },
  dataPixelSaved: {
    defaultMessage: "Data Pixel saved successfully",
    id: "audience.pixels.event.dataPixelSaved",
  },
  dataProvider: {
    defaultMessage: "Data Provider*",
    id: "audience.pixels.data.dataProvider",
  },
  dataProviderSelectedNextSteps: {
    defaultMessage:
      "Next Step: Please generate code for this Data Pixel and implement with your data partner.",
    id: "audience.pixels.data.dataProviderSelectedNextSteps",
  },
  dataProviderSelectedNote: {
    defaultMessage:
      'Note: By selecting "Client pays MediaMath", the Client will pay MediaMath for Data Pixel costs and MediaMath will relay payment to the Data Provider. Alternatively, selecting a Data Provider labeled "Client pays vendor directly" means the Client assumes responsibility to pay the Data Provider directly and will not be billed by MediaMath.',
    id: "audience.pixels.data.dataProviderSelectedNote",
  },
  dataType: {
    defaultMessage: "Data Type",
    id: "audience.pixels.event.dataType",
  },
  date: {
    defaultMessage: "Date",
    id: "audience.pixels.list.changelog.date",
  },
  dateCreated: {
    defaultMessage: "Date Created",
    id: "audience.segments.list.dateCreated",
  },
  days: {
    defaultMessage: "Days",
    id: "audience.segments.adaptive.days",
  },
  deactivate: {
    defaultMessage: "Deactivate",
    id: "audience.pixels.list.actions.deactivate",
  },
  details: {
    defaultMessage: "Details",
    id: "audience.pixels.list.summary.details",
  },
  duplicate: {
    defaultMessage: "Duplicate",
    id: "audience.segments.list.contextMenu.duplicate",
  },
  dynamic: {
    defaultMessage: "Dynamic",
    id: "audience.pixels.event.dynamic",
  },
  edit: {
    defaultMessage: "Edit",
    id: "audience.pixels.list.actions.edit",
  },
  editBehavior: {
    defaultMessage: "Edit Behavior",
    id: "audience.segments.editBehavior",
  },
  editEventPixel: {
    defaultMessage: "Edit Event Pixel",
    id: "audience.pixels.event.editEventPixel",
  },
  editPixel: {
    defaultMessage: "Edit Pixel",
    id: "audience.pixels.list.editPixel",
  },
  editSegment: {
    defaultMessage: "Edit Segment",
    id: "audience.segments.list.editSegment",
  },
  editSegmentGroup: {
    defaultMessage: "Edit Segment Group",
    id: "audience.segmentGroups.list.editSegmentGroup",
  },
  editStrategy: {
    defaultMessage: "Edit Strategy",
    id: "audience.strategyAssignment.columns.editStrategy",
  },
  eligible: {
    defaultMessage: "Eligible",
    id: "audience.pixels.list.summary.eligible",
  },
  emailPixelCode: {
    defaultMessage: "Email Pixel Code",
    id: "audience.pixels.list.actions.emailPixelCode",
  },
  emptyMessage: {
    defaultMessage: "No results found.",
    id: "audience.pixels.list.emptyMessage",
  },
  enterCommaSeparatedValues: {
    defaultMessage: "Enter comma-separated values",
    id: "audience.segments.standard.enterCommaSeparatedValues",
  },
  enterModelName: {
    defaultMessage: "Enter model name",
    id: "audience.lookalikes.form.modelNamePlaceholder",
  },
  enterNumber: {
    defaultMessage: "Enter number",
    id: "audience.segments.standard.enterNumber",
  },
  event: {
    defaultMessage: "Event",
    id: "audience.pixels.event.event",
  },
  eventAttribute: {
    defaultMessage: "Event Attribute",
    id: "audience.segments.behavior.eventAttribute",
  },
  eventBtn: {
    defaultMessage: "Event",
    id: "audience.pixels.list.btn.eventBtn",
  },
  eventPixelNotSaved: {
    defaultMessage: "Event Pixel could not be saved",
    id: "audience.pixels.event.eventPixelNotSaved",
  },
  eventPixels: {
    defaultMessage: "Event Pixels",
    id: "audience.segments.adaptive.sidepanel.eventPixels",
  },
  eventPixelSaved: {
    defaultMessage: "Event Pixel saved successfully",
    id: "audience.pixels.event.eventPixelSaved",
  },
  eventUrlError: {
    defaultMessage: "Please enter a valid URL",
    id: "audience.pixels.event.eventUrlError",
  },
  eventUrls: {
    defaultMessage: "Event URLs",
    id: "audience.pixels.list.summary.eventUrls",
  },
  eventUrlsOpt: {
    defaultMessage: "Event URLs (optional)",
    id: "audience.pixels.event.eventUrlsOpt",
  },
  exportHistory: {
    defaultMessage: "EXPORT HISTORY",
    id: "audience.pixels.list.actions.exportHistory",
  },
  exportPixelLoadHistory: {
    defaultMessage: "Export Pixel Load History",
    id: "audience.pixels.list.actions.exportPixelLoadHistory",
  },
  exportPixelLoadHistoryError: {
    defaultMessage: "Pixel Load History could not be exported.",
    id: "audience.pixels.list.exportPixelLoadHistoryError",
  },
  exportPixelTag: {
    defaultMessage: "Export Pixel Tag",
    id: "audience.pixels.list.actions.exportPixelTag",
  },
  exportTableData: {
    defaultMessage: "Export Table Data",
    id: "audience.pixels.list.actions.exportTableData",
  },
  expression: {
    defaultMessage: "Expression",
    id: "audience.segments.standard.expression",
  },
  externalIdentifier: {
    defaultMessage: "External Identifier",
    id: "audience.pixels.list.summary.externalIdentifier",
  },
  failed: {
    defaultMessage: "Failed",
    id: "audience.lookalikes.status.failed",
  },
  fileName: {
    defaultMessage: "audience-pixel-data",
    id: "aaudience.pixels.list.actions.exportTableData.fileName",
  },
  fixed: {
    defaultMessage: "Fixed",
    id: "audience.pixels.event.fixed",
  },
  formErrorSummary: {
    defaultMessage:
      "{count, plural, one {# error to correct} other {# errors to correct}}",
    id: "audience.lookalikes.form.errorSummary",
    parameterized: true,
  },
  frequency: {
    defaultMessage: "Frequency",
    id: "audience.segments.adaptive.frequency",
  },
  hideExpression: {
    defaultMessage: "Hide Expression",
    id: "audience.segments.segment.form.hideExpression",
  },
  hours: {
    defaultMessage: "Hours",
    id: "audience.segments.adaptive.hours",
  },
  iframeMathTag: {
    defaultMessage: "iFrame MathTag Container",
    id: "audience.pixels.event.tag.iframe",
  },
  imgMathTag: {
    defaultMessage: "Image MathTag",
    id: "audience.pixels.event.tag.img",
  },
  imgMathTagDart: {
    defaultMessage: "Image MathTag for CM360 Floodlight",
    id: "audience.pixels.event.tag.imgDart",
  },
  implementationMethod: {
    defaultMessage: "Implementation Method",
    id: "audience.pixels.event.implementationMethod",
  },
  implementationMethodTitle: {
    defaultMessage: "Implementation Method",
    id: "audience.pixels.data.implementationMethodTitle",
  },
  impression: {
    defaultMessage: "Impression",
    id: "audience.segments.adaptive.sidepanel.impression",
  },
  impressions: {
    defaultMessage: "Impressions",
    id: "audience.segments.adaptive.sidepanel.impressions",
  },
  inactive: {
    defaultMessage: "Inactive",
    id: "audience.status.inactive",
  },
  inactiveSegmentGroupWarning: {
    defaultMessage:
      "This segment group is inactive, applying it to Strategies will not impact delivery.",
    id: "audience.segmentGroups.form.inactiveSegmentGroupWarning",
  },
  inProgress: {
    defaultMessage: "In Progress",
    id: "audience.lookalikes.status.inProgress",
  },
  jsMathTag: {
    defaultMessage:
      "JavaScript MathTag Container (Recommended for optimal performance)",
    id: "audience.pixels.event.tag.js",
  },
  keywords: {
    defaultMessage: "Keywords",
    id: "audience.pixels.list.summary.keywords",
  },
  knowledgeBase: {
    defaultMessage: "See the MediaMath Knowledge Base for more information.",
    id: "audience.pixels.event.knowledgeBase",
  },
  lastBuildDate: {
    defaultMessage: "Last Build Date",
    id: "audience.lookalikes.list.column.lastBuildDate",
  },
  listOfPixels: {
    defaultMessage: "List of Pixels",
    id: "audience.pixels.list.emailCode.listOfPixels",
  },
  loading: {
    defaultMessage: "Loading...",
    id: "audience.pixels.event.loading",
  },
  loadingEventAttributes: {
    defaultMessage: "Loading Event Attributes...",
    id: "audience.segments.standard.loadingEventAttributes",
  },
  lookalikeCreateError: {
    defaultMessage: "Failed to create lookalike model",
    id: "audience.lookalikes.form.createError",
  },
  lookalikeCreatePartial: {
    defaultMessage: "Lookalike model partially created: {detail}",
    id: "audience.lookalikes.form.createPartial",
    parameterized: true,
  },
  lookalikeCreateSuccess: {
    defaultMessage: "Lookalike model created",
    id: "audience.lookalikes.form.createSuccess",
  },
  lookalikeCreateVariantUnknownError: {
    defaultMessage: "Unknown error",
    id: "audience.lookalikes.form.createVariantUnknownError",
  },
  lookalikeModelName: {
    defaultMessage: "Lookalike Model Name",
    id: "audience.lookalikes.form.modelName",
  },
  lookalikesTabName: {
    defaultMessage: "Lookalikes",
    id: "audience.lookalikes.tab.name",
  },
  macrosNote: {
    defaultMessage:
      "You may insert macros as needed. Available macros are: [RANDOM_NUMBER].",
    id: "audience.pixels.event.macrosNote",
  },
  message: {
    defaultMessage: "Message (optional):",
    id: "audience.pixels.list.emailCode.message",
  },
  minutes: {
    defaultMessage: "Minutes",
    id: "audience.segments.adaptive.minutes",
  },
  missingSegmentGroupHeader: {
    defaultMessage: "Segment Group List action is missing/incorrect",
    id: "audience.segmentGroups.form.missingSegmentGroupHeader",
  },
  modelDetails: {
    defaultMessage: "Model Details",
    id: "audience.lookalikes.sidepanel.modelDetails",
  },
  modelId: {
    defaultMessage: "Model ID",
    id: "audience.lookalikes.list.column.modelId",
  },
  modelName: {
    defaultMessage: "Lookalike Model",
    id: "audience.lookalikes.list.column.modelName",
  },
  modelNameError: {
    defaultMessage: "Please enter a model name",
    id: "audience.lookalikes.form.modelNameError",
  },
  modified: {
    defaultMessage: "Modified",
    id: "audience.pixels.list.modified",
  },
  months: {
    defaultMessage: "Months",
    id: "audience.segments.adaptive.months",
  },
  name: {
    defaultMessage: "Name*",
    id: "audience.pixels.event.name",
  },
  nameError: {
    defaultMessage: "The name must include 1-256 characters",
    id: "audience.pixels.event.nameError",
  },
  namePlaceholder: {
    defaultMessage: "e.g. Homepage, Landing Page 1, Thank You Page",
    id: "audience.pixels.event.namePlaceholder",
  },
  newAdaptiveSegment: {
    defaultMessage: "New Adaptive Segment",
    id: "audience.segments.adaptive.newAdaptiveSegment",
  },
  newAudienceSegmentGroup: {
    defaultMessage: "New Audience Segment Group",
    id: "audience.segmentGroups.form.newAudienceSegmentGroup",
  },
  newContextualSegmentGroup: {
    defaultMessage: "New Contextual Segment Group",
    id: "audience.segmentGroups.form.newContextualSegmentGroup",
  },
  newDataPixel: {
    defaultMessage: "New Data Pixel",
    id: "audience.pixels.data.newDataPixel",
  },
  newEventPixel: {
    defaultMessage: "New Event Pixel",
    id: "audience.pixels.event.newEventPixel",
  },
  newLookalikeModel: {
    defaultMessage: "New Lookalike Model",
    id: "audience.lookalikes.form.newTitle",
  },
  newPixelBtn: {
    defaultMessage: "NEW PIXEL",
    id: "audience.pixels.list.btn.newPixelBtn",
  },
  newSegmentAudienceGroup: {
    defaultMessage: "Audience Group",
    id: "audience.segmentGroups.list.newSegmentAudienceGroup",
  },
  newSegmentBtn: {
    defaultMessage: "NEW SEGMENT",
    id: "audience.pixels.list.btn.newSegmentBtn",
  },
  newSegmentContextualGroup: {
    defaultMessage: "Contextual Group",
    id: "audience.segmentGroups.list.newSegmentContextualGroup",
  },
  newSegmentGroupsBtn: {
    defaultMessage: "ADD GROUPS",
    id: "audience.segmentGroups.list.newSegmentGroupsBtn",
  },
  newStandardSegment: {
    defaultMessage: "New Standard Segment",
    id: "audience.segments.standard.newStandardSegment",
  },
  newValue: {
    defaultMessage: "New Value",
    id: "audience.pixels.list.changelog.newValue",
  },
  no: {
    defaultMessage: "No",
    id: "audience.pixels.list.summary.no",
  },
  noEligibleRegions: {
    defaultMessage:
      "This advertiser has no eligible regions for lookalike modeling.",
    id: "audience.lookalikes.form.noEligibleRegions",
  },
  noEventAttr: {
    defaultMessage: "No event attributes available",
    id: "audience.segments.standard.sidepanel.noEventAttr",
  },
  noSelectedBehaviors: {
    defaultMessage: "No behaviors selected",
    id: "audience.segments.standard.sidepanel.noSelectedBehaviors",
  },
  notBetween: {
    defaultMessage: "Not Between",
    id: "audience.segments.adaptive.notBetween",
  },
  notEnoughSeeds: {
    defaultMessage: "Not Enough Seeds",
    id: "audience.lookalikes.status.notEnoughSeeds",
  },
  notWithin: {
    defaultMessage: "Not Within",
    id: "audience.segments.adaptive.notWithin",
  },
  numeric: {
    defaultMessage: "Numeric",
    id: "audience.pixels.event.numeric",
  },
  numSelected: {
    defaultMessage: "{numSelected} Selected",
    id: "audience.pixels.list.numSelected",
    parameterized: true,
  },
  oldValue: {
    defaultMessage: "Old Value",
    id: "audience.pixels.list.changelog.oldValue",
  },
  onlineScoring: {
    defaultMessage: "Online Scoring",
    id: "audience.lookalikes.sidepanel.onlineScoring",
  },
  onlineScoringSiteVisitors: {
    defaultMessage: "Online Scoring (site visitors)",
    id: "audience.lookalikes.form.remarketingUserType",
  },
  operator: {
    defaultMessage: "Operator",
    id: "audience.segments.behavior.operator",
  },
  OR: {
    defaultMessage: "OR",
    id: "audience.segmentGroups.form.segmentOperator.or",
  },
  overrideAdvAttr: {
    defaultMessage: "Override Advertiser Level Custom Attributes",
    id: "audience.pixels.event.overrideAdvAttr",
  },
  pageErrors: {
    defaultMessage: "There are errors on the page",
    id: "audience.pixels.event.pageErrors",
  },
  permissionsLoadError: {
    defaultMessage: "Failed to load model permissions for this advertiser.",
    id: "audience.lookalikes.form.permissionsLoadError",
  },
  pixelCodes: {
    defaultMessage: "Pixel Codes",
    id: "audience.pixels.list.summary.pixelCodes",
  },
  pixelID: {
    defaultMessage: "Pixel ID",
    id: "audience.pixels.list.pixelID",
  },
  pixelLoads: {
    defaultMessage: "Pixel Loads",
    id: "audience.pixels.list.pixelLoads",
  },
  pixelName: {
    defaultMessage: "Pixel Name",
    id: "audience.pixels.list.pixelName",
  },
  pixels: {
    defaultMessage: "Pixels",
    id: "audience.pixels",
  },
  pixelStatus: {
    defaultMessage: "Pixel Status",
    id: "audience.pixels.list.pixelStatus",
  },
  pixelTag: {
    defaultMessage: "Pixel Tag",
    id: "audience.pixels.list.pixelTag",
  },
  pixelType: {
    defaultMessage: "Pixel Type",
    id: "audience.pixels.list.pixelType",
  },
  pixelTypeTitle: {
    defaultMessage: "Pixel Type",
    id: "audience.pixels.event.pixelTypeTitle",
  },
  pricing: {
    defaultMessage: "Pricing",
    id: "audience.pixels.list.summary.pricing",
  },
  pricingCPM: {
    defaultMessage: "CPM",
    id: "audience.data.cpm",
  },
  pricingCPMError: {
    defaultMessage: "Please enter a valid CPM",
    id: "audience.pixels.data.pricingCPMError",
  },
  pricingCPMUsd: {
    defaultMessage: "CPM (USD)",
    id: "audience.data.cpmUsd",
  },
  pricingMediaCost: {
    defaultMessage: "% of Media Cost",
    id: "audience.pixels.data.mediaCost",
  },
  pricingMediaCostError: {
    defaultMessage: "Please enter a valid % of Media Cost",
    id: "audience.pixels.data.pricingMediaCostError",
  },
  pricingTitle: {
    defaultMessage: "Pricing*",
    id: "audience.pixels.data.pricingTitle",
  },
  prospecting: {
    defaultMessage: "Prospecting",
    id: "audience.lookalikes.sidepanel.prospecting",
  },
  prospectingUserType: {
    defaultMessage: "Prospecting (non-site visitors)",
    id: "audience.lookalikes.form.prospectingUserType",
  },
  providerAdvertiserName: {
    defaultMessage: "Provider/Advertiser Name",
    id: "audience.pixels.list.providerAdvertiserName",
  },
  providerId: {
    defaultMessage: "Provider ID",
    id: "audience.pixels.list.summary.providerId",
  },
  recency: {
    defaultMessage: "Recency",
    id: "audience.segments.adaptive.recency",
  },
  region: {
    defaultMessage: "Region",
    id: "audience.lookalikes.form.region",
  },
  regionError: {
    defaultMessage: "Please select a region",
    id: "audience.lookalikes.form.regionError",
  },
  regionTooltip: {
    defaultMessage:
      "Select a region. This will allow selection of one or more countries. If only EMEA can be selected as a region, reach out to Client Service to ask that data sharing with MediaMath be activated. Data sharing is required in order to create MediaMath Lookalike Audiences in other regions.",
    id: "audience.lookalikes.form.regionTooltip",
  },
  reset: {
    defaultMessage: "Reset",
    id: "audience.segments.adaptive.reset",
  },
  retrieve90days: {
    defaultMessage: "You can retrieve up to 90 days of data.",
    id: "audience.pixels.list.exportHistory.retrieve90days",
  },
  retry: {
    defaultMessage: "Retry",
    id: "audience.lookalikes.form.retry",
  },
  revenue: {
    defaultMessage: "Revenue",
    id: "audience.pixels.event.revenue",
  },
  revenueAttr: {
    defaultMessage: "Revenue Attribution Pair",
    id: "audience.pixels.event.revenueAttr",
  },
  revenueTtip: {
    defaultMessage:
      "Set the Revenue and Currency attribution values for future pixel fires. These settings will automatically enable reporting for campaigns using these merit event pixels.",
    id: "audience.pixels.event.revenueTtip",
  },
  rmxConversionMinutes: {
    defaultMessage: "RMX Conversion Minutes",
    id: "audience.pixels.list.summary.rmxConversionMinutes",
  },
  rmxConversionType: {
    defaultMessage: "RMX Conversion Type",
    id: "audience.pixels.list.summary.rmxConversionType",
  },
  rmxFriendly: {
    defaultMessage: "RMX Friendly",
    id: "audience.pixels.list.summary.rmxFriendly",
  },
  rmxMerit: {
    defaultMessage: "RMX Merit",
    id: "audience.pixels.list.summary.rmxMerit",
  },
  save: {
    defaultMessage: "SAVE",
    id: "audience.pixels.event.save",
  },
  saveAs: {
    defaultMessage: "SAVE AS",
    id: "audience.pixels.event.saveAs",
  },
  saveAsClose: {
    defaultMessage: "SAVE AS AND CLOSE",
    id: "audience.pixels.event.saveAsClose",
  },
  saveClose: {
    defaultMessage: "SAVE AND CLOSE",
    id: "audience.pixels.event.saveClose",
  },
  searchPixels: {
    defaultMessage: "Search pixels…",
    id: "audience.lookalikes.form.searchPixels",
  },
  seedPixels: {
    defaultMessage: "Seed Pixels",
    id: "audience.lookalikes.sidepanel.seedPixels",
  },
  seedPixelsError: {
    defaultMessage: "Select between 1 and 3 eligible seed pixels",
    id: "audience.lookalikes.form.seedPixelsError",
  },
  seedPixelType: {
    defaultMessage: "Seed Pixel Type",
    id: "audience.lookalikes.sidepanel.seedPixelType",
  },
  seedType: {
    defaultMessage: "Seed Type",
    id: "audience.lookalikes.form.seedTypeLabel",
  },
  segmentCodeColumn: {
    defaultMessage: "Code",
    id: "audience.segmentGroups.form.segmentCodeColumn",
  },
  segmentExport: {
    defaultMessage: "Segment Export",
    id: "audience.segments.list.segmentExportBtn",
  },
  segmentGroupCurrency: {
    defaultMessage: "Currency:",
    id: "audience.segmentGroups.form.segmentGroupCurrency",
  },
  segmentGroupCurrencyTooltip: {
    defaultMessage:
      "Changing the currency updates how costs are displayed. This setting is not saved and will reset when the page reloads. The actual currency used will be defined by the Campaign and Strategy this group is attached to.",
    id: "audience.segmentGroups.form.segmentGroupCurrencyTooltip",
  },
  segmentGroupEdit: {
    defaultMessage: "EDIT",
    id: "audience.segmentGroups.form.segmentGroupEdit",
  },
  segmentGroupEstimatedCPMRange: {
    defaultMessage: "Estimated Group CPM Range: {minCost} - {maxCost}",
    id: "audience.segmentGroups.form.estimated.cpm.range",
    parameterized: true,
  },
  segmentGroupID: {
    defaultMessage: "Group ID",
    id: "audience.segmentGroups.list.groupId",
  },
  segmentGroupMaxCost: {
    defaultMessage: "Group maximum cost: {maxCost}",
    id: "audience.segmentGroups.form.segmentGroupMaxCost",
    parameterized: true,
  },
  segmentGroupMaxCostTooltip: {
    defaultMessage:
      "The maximum CPM cost for the Group. The Group will not be applied to any {segmentType} Segments with a CPM cost higher than this value.",
    id: "audience.segmentGroups.form.segmentGroupMaxCostTooltip",
    parameterized: true,
  },
  segmentGroupModified: {
    defaultMessage: "Modified",
    id: "audience.segmentGroups.list.modified",
  },
  segmentGroupName: {
    defaultMessage: "Group Name",
    id: "audience.segmentGroups.list.groupName",
  },
  segmentGroupNotSaved: {
    defaultMessage: "{type} Group could not be saved",
    id: "audience.segmentGroups.form.segmentGroupNotSaved",
    parameterized: true,
  },
  segmentGroupSaved: {
    defaultMessage: "{type} Group saved successfully",
    id: "audience.segmentGroups.form.dataPixelSaved",
    parameterized: true,
  },
  segmentGroupSegments: {
    defaultMessage: "Segments",
    id: "audience.segmentGroups.list.segments",
  },
  segmentGroupsTabName: {
    defaultMessage: "Audience/Contextual Groups",
    id: "audience.segmentGroups.segmentGroupsTabName",
  },
  segmentGroupStatus: {
    defaultMessage: "Group Status",
    id: "audience.segmentGroups.list.groupStatus",
  },
  segmentGroupStrategiesTargeted: {
    defaultMessage: "Strategies Targeted",
    id: "audience.segmentGroups.list.strategiesTargeted",
  },
  segmentGroupType: {
    defaultMessage: "Group Type",
    id: "audience.segmentGroups.list.groupType",
  },
  segmentId: {
    defaultMessage: "Segment ID",
    id: "audience.segments.list.segmentId",
  },
  segmentName: {
    defaultMessage: "Segment Name",
    id: "audience.segments.list.segmentName",
  },
  segmentNameColumn: {
    defaultMessage: "Segment",
    id: "audience.segmentGroups.form.segmentColumn",
  },
  segmentOperatorTitle: {
    defaultMessage: "Group Operator:",
    id: "audience.segmentGroups.form.segmentOperatorTitle",
  },
  segments: {
    defaultMessage: "Segments",
    id: "audience.segments",
  },
  segmentsAvailable: {
    defaultMessage: "Segments Available",
    id: "audience.lookalikes.status.segmentsAvailable",
  },
  segmentSelectionDrawerTitle: {
    defaultMessage: "Selected Segments",
    id: "audience.segmentGroups.form.segmentSelectionDrawerTitle",
  },
  segmentSelectionSidePanelHeader: {
    defaultMessage: "Select Segments",
    id: "audience.segmentGroups.form.segmentSelectionSidePanelHeader",
  },
  segmentSize: {
    defaultMessage: "Segment Size",
    id: "audience.segments.adaptive.segmentSize",
  },
  segmentSizeColumn: {
    defaultMessage: "Total Size",
    id: "audience.segmentGroups.form.segmentSizeColumn",
  },
  segmentSizeUpdated: {
    defaultMessage: "Segment Size Updated",
    id: "audience.segments.adaptive.segmentSizeUpdated",
  },
  segmentType: {
    defaultMessage: "Segment Type",
    id: "audience.segments.list.segmentType",
  },
  segmentTypeColumn: {
    defaultMessage: "Type",
    id: "audience.segmentGroups.form.segmentTypeColumn",
  },
  select: {
    defaultMessage: "Select",
    id: "audience.pixels.event.select",
  },
  selectADate: {
    defaultMessage: "Select a date",
    id: "audience.segments.adaptive.selectADate",
  },
  selectADateRange: {
    defaultMessage: "Select a date range",
    id: "audience.segments.adaptive.selectADateRange",
  },
  selectAdvertiser: {
    defaultMessage: "Select an Advertiser",
    id: "audience.pixels.event.selectAdvertiser",
  },
  selectAdvertiserError: {
    defaultMessage: "Please select an advertiser",
    id: "audience.pixels.event.selectAdvertiserError",
  },
  selectAgency: {
    defaultMessage: "Select an Agency",
    id: "audience.pixels.data.selectAgency",
  },
  selectAgencyError: {
    defaultMessage: "Please select an agency",
    id: "audience.pixels.data.selectAgencyError",
  },
  selectCountries: {
    defaultMessage: "Select countries",
    id: "audience.lookalikes.form.selectCountries",
  },
  selectCurrecyError: {
    defaultMessage: "Please select a currency",
    id: "audience.pixels.event.selectCurrecyError",
  },
  selectCurrency: {
    defaultMessage: "Select Currency",
    id: "audience.pixels.event.selectCurrency",
  },
  selectDataPixel: {
    defaultMessage: "Select a data pixel",
    id: "audience.lookalikes.form.selectDataPixel",
  },
  selectDataProvider: {
    defaultMessage: "Select a Data Provider",
    id: "audience.pixels.data.selectDataProvider",
  },
  selectDataProviderError: {
    defaultMessage: "Please select a data provider",
    id: "audience.pixels.data.selectDataProviderError",
  },
  selectDataType: {
    defaultMessage: "Please select a Data Type",
    id: "audience.pixels.event.selectDataType",
  },
  selectDate: {
    defaultMessage: "Select a date or date range",
    id: "audience.segments.standard.selectDate",
  },
  selectedBehaviors: {
    defaultMessage: "Selected Behaviors",
    id: "audience.segments.selectedBehaviors",
  },
  selectedPixels: {
    defaultMessage: "Selected",
    id: "audience.lookalikes.form.selectedPixels",
  },
  selectEventAttr: {
    defaultMessage: "Select event attribute",
    id: "audience.segments.standard.selectEventAttr",
  },
  selectOperator: {
    defaultMessage: "Select operator",
    id: "audience.segments.standard.selectOperator",
  },
  selectParam: {
    defaultMessage: "Select Parameter",
    id: "audience.pixels.event.selectParam",
  },
  selectParamError: {
    defaultMessage: "Please select a parameter",
    id: "audience.pixels.event.selectParamError",
  },
  selectParameter: {
    defaultMessage: "Select Parameter",
    id: "audience.pixels.event.selectParameter",
  },
  selectParameterError: {
    defaultMessage: "Please select a parameter",
    id: "audience.pixels.event.selectParameterError",
  },
  selectRegion: {
    defaultMessage: "Select a region",
    id: "audience.lookalikes.form.selectRegion",
  },
  selectSegmentAssignmentError: {
    defaultMessage: "Please select at least one segment assignment",
    id: "audience.segmentGroups.form.selectSegmentAssignmentError",
  },
  selectStandardAttr: {
    defaultMessage: "Select Standard Attributes",
    id: "audience.pixels.event.selectStandardAttr",
  },
  selectUnit: {
    defaultMessage: "Select Unit",
    id: "audience.segments.adaptive.selectUnit",
  },
  selectVisitorRecency: {
    defaultMessage: "Select recency",
    id: "audience.lookalikes.form.selectVisitorRecency",
  },
  sendEmail: {
    defaultMessage: "SEND EMAIL",
    id: "audience.pixels.list.emailCode.sendEmail",
  },
  showExpression: {
    defaultMessage: "Show Expression",
    id: "audience.segments.segment.form.showExpression",
  },
  siteVisitorRecency: {
    defaultMessage: "Site Visitor Recency",
    id: "audience.lookalikes.sidepanel.siteVisitorRecency",
  },
  siteVisitorRecencyValue: {
    defaultMessage: "{startWindow}–{endWindow} days",
    id: "audience.lookalikes.sidepanel.siteVisitorRecencyValue",
    parameterized: true,
  },
  size: {
    defaultMessage: "Size",
    id: "audience.segments.list.size",
  },
  sizeEditTtip: {
    defaultMessage:
      "Number of unique users who qualified for this segment within the last 45 days.",
    id: "audience.segments.edit.sizeEditTtip",
  },
  sizeInfo: {
    defaultMessage:
      "This size reflects the previous segment logic. Save changes to update the size.",
    id: "audience.segments.edit.sizeInfo",
  },
  sizeTtip: {
    defaultMessage:
      "Number of unique users in the segment within the last 45 days. Size calculation depends on the selected Segment Type.",
    id: "audience.segments.list.sizeTtip",
  },
  sizeUpdated: {
    defaultMessage: "Size Updated",
    id: "audience.segments.list.sizeUpdated",
  },
  sizeUpdatedTtip: {
    defaultMessage:
      "The last time the segment size was calculated. Size updates stop when the segment is not in active use.",
    id: "audience.segments.list.sizeUpdatedTtip",
  },
  sizeWarning: {
    defaultMessage: "Size updates stop when the segment is not in active use.",
    id: "audience.segments.form.sizeWarning",
  },
  standard: {
    defaultMessage: "Standard",
    id: "audience.segments.list.column.standard",
  },
  standardAttr: {
    defaultMessage: "Standard Attributes",
    id: "audience.pixels.event.standardAttr",
  },
  standardSegment: {
    defaultMessage: "Standard Segment",
    id: "audience.segments.list.btn.standardSegment",
  },
  standardSegmentFailed: {
    defaultMessage: "Standard Segment could not be saved",
    id: "audience.segments.segment.form.standardSegmentFailed",
  },
  standardSegmentName: {
    defaultMessage: "Standard Segment Name",
    id: "audience.segments.segment.form.standardSegmentName",
  },
  standardSegmentSaved: {
    defaultMessage: "Standard Segment saved successfully",
    id: "audience.segments.segment.form.standardSegmentSaved",
  },
  startSharingError: {
    defaultMessage: "Please accept the Terms of Use",
    id: "audience.lookalikes.form.startSharingError",
  },
  status: {
    defaultMessage: "Status",
    id: "audience.pixels.event.status",
  },
  strategiesLabel: {
    defaultMessage: "List of Strategies the Group is applied to:",
    id: "audience.segmentGroups.form.strategiesLabel",
  },
  strategiesTitle: {
    defaultMessage: "Strategies",
    id: "audience.segmentGroups.form.strategiesTitle",
  },
  strategyAssignmentPermissionWarning: {
    defaultMessage:
      "Strategy visibility may be limited based on your permissions.",
    id: "audience.segmentGroups.form.strategyAssignmentPermissionWarning",
  },
  strategyId: {
    defaultMessage: "Strategy ID",
    id: "audience.segmentGroups.form.strategyIdColumn",
  },
  strategyName: {
    defaultMessage: "Strategy Name",
    id: "audience.segmentGroups.form.strategyNameColumn",
  },
  strategyStatus: {
    defaultMessage: "Strategy Status",
    id: "audience.segments.adaptive.sidepanel.strategyStatus",
  },
  string: {
    defaultMessage: "String",
    id: "audience.pixels.event.string",
  },
  t1ClientInvoiced: {
    defaultMessage:
      "MediaMath pays data provider (Client invoiced by MediaMath)",
    id: "audience.pixels.data.t1ClientInvoiced",
  },
  t1ClientNotInvoiced: {
    defaultMessage:
      "Client pays data provider directly (Client is not invoiced by MediaMath)",
    id: "audience.pixels.data.t1ClientNotInvoiced",
  },
  tag: {
    defaultMessage: "Tag",
    id: "audience.pixels.list.summary.tag",
  },
  tagType: {
    defaultMessage: "Tag Type",
    id: "audience.pixels.list.summary.tagType",
  },
  theLast: {
    defaultMessage: "the last",
    id: "audience.segments.adaptive.theLast",
  },
  timeInterval: {
    defaultMessage: "Time Interval",
    id: "audience.segments.adaptive.timeInterval",
  },
  to: {
    defaultMessage: "To:",
    id: "audience.pixels.list.emailCode.to",
  },
  toastError: {
    defaultMessage: "Error",
    id: "audience.pixels.list.toastError",
  },
  toastSuccess: {
    defaultMessage: "Success",
    id: "audience.pixels.list.toastSuccess",
  },
  toPlaceHolder: {
    defaultMessage: "Type Recipient Email(s) separated by a comma",
    id: "audience.pixels.list.emailCode.toPlaceHolder",
  },
  type: {
    defaultMessage: "Type",
    id: "audience.pixels.list.changelog.type",
  },
  typeMessage: {
    defaultMessage: "Type Message",
    id: "audience.pixels.list.emailCode.typeMessage",
  },
  typeToSearch: {
    defaultMessage: "Type to search",
    id: "audience.segments.list.filter.advertiser.placeholder",
  },
  uniquePixelLoads: {
    defaultMessage: "Unique Pixel Loads",
    id: "audience.pixels.list.uniquePixelLoads",
  },
  unsavedChanges: {
    defaultMessage: "There are unsaved changes on the page",
    id: "audience.pixels.event.unsavedChanges",
  },
  updatedOn: {
    defaultMessage: "Updated On",
    id: "audience.pixels.list.summary.updatedOn",
  },
  updatePixelSuccessMessage: {
    defaultMessage: "Pixel(s) saved successfully",
    id: "audience.pixels.list.updatePixelSuccessMessage",
  },
  updateSegmentGroupSuccessMessage: {
    defaultMessage: "Segment Group(s) saved successfully",
    id: "audience.segmentGroups.list.updateSegmentGroupSuccessMessage",
  },
  userType: {
    defaultMessage: "User Type",
    id: "audience.lookalikes.sidepanel.userType",
  },
  userTypesError: {
    defaultMessage: "Select at least one user type",
    id: "audience.lookalikes.form.userTypesError",
  },
  userTypeTooltip: {
    defaultMessage:
      "The seed audience trains the Lookalike Model. Prospecting scores users who have not visited your site in the last 60 days. Online Scoring scores site visitors within the selected recency window. Both options identify users who most closely resemble the seed audience.",
    id: "audience.lookalikes.form.userTypeTooltip",
  },
  value: {
    defaultMessage: "Value",
    id: "audience.segments.behavior.value",
  },
  view: {
    defaultMessage: "View",
    id: "audience.segments.list.contextMenu.view",
  },
  viewPixelLoad: {
    defaultMessage: "View pixel load counts for the past number of days:",
    id: "audience.pixels.list.exportHistory.viewPixelLoad",
  },
  viewSummary: {
    defaultMessage: "View Summary",
    id: "audience.lookalikes.list.actions.viewSummary",
  },
  visitorRecency: {
    defaultMessage: "Visitor Recency",
    id: "audience.lookalikes.form.visitorRecencyLabel",
  },
  visitorRecencyError: {
    defaultMessage: "Select a visitor recency",
    id: "audience.lookalikes.form.visitorRecencyError",
  },
  warning: {
    defaultMessage: "Warning",
    id: "audience.segment.groups.warning",
  },
  weeks: {
    defaultMessage: "Weeks",
    id: "audience.segments.adaptive.weeks",
  },
  within: {
    defaultMessage: "Within",
    id: "audience.segments.adaptive.within",
  },
  yes: {
    defaultMessage: "Yes",
    id: "audience.pixels.list.summary.yes",
  },
});

export default AudienceMessages;
